import React from 'react';
import AiManuscriptPreference from './userProfileBuilder/fields/aiManuscriptPreference';

export const PublicProfileReadingPreferences = ({editable, initialValue, updating, onUpdate, t}) => {
  if (!editable) return null;
  return (
    <section style={{marginTop: 'var(--br-space-4)'}}>
      <h3>{t('ReadingPreferences')}</h3>
      <AiManuscriptPreference initialValue={initialValue}
        updating={updating} onUpdate={onUpdate} />
    </section>
  );
};

export default PublicProfileReadingPreferences;
